import {
  ChapterDto,
  ChapterFlashCardsStatsDto,
  ChapterLecturesStatsDto,
  ChapterSkillsStatsDto,
  ChapterStatsDto,
  OrganizingChapterDto,
  OrganizingLessonDto,
  State,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import {
  TOGGLE_LESSON_STATE,
  TOGGLE_LESSON_STATE_SUCCESS,
  TOGGLE_LESSON_STATE_ERROR,
} from "../lesson/actionTypes";
import {
  ADD_CHAPTER,
  ADD_CHAPTER_ERROR,
  ADD_CHAPTER_SUCCESS,
  ActionTypes,
  DELETE_CHAPTER,
  DELETE_CHAPTER_CONSENT,
  DELETE_CHAPTER_ERROR,
  DELETE_CHAPTER_SUCCESS,
  GET_CHAPTER,
  GET_CHAPTERS,
  GET_CHAPTERS_ERROR,
  GET_CHAPTERS_FLASH_CARDS_STATS,
  GET_CHAPTERS_FLASH_CARDS_STATS_ERROR,
  GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS,
  GET_CHAPTERS_LECTURES_STATS,
  GET_CHAPTERS_LECTURES_STATS_ERROR,
  GET_CHAPTERS_LECTURES_STATS_SUCCESS,
  GET_CHAPTERS_SKILLS_STATS,
  GET_CHAPTERS_SKILLS_STATS_ERROR,
  GET_CHAPTERS_SKILLS_STATS_SUCCESS,
  GET_CHAPTERS_STATS,
  GET_CHAPTERS_STATS_ERROR,
  GET_CHAPTERS_STATS_SUCCESS,
  GET_CHAPTERS_SUCCESS,
  GET_CHAPTER_ERROR,
  GET_CHAPTER_LIST_BY_SUBJECT,
  GET_CHAPTER_LIST_BY_SUBJECT_ERROR,
  GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS,
  GET_CHAPTER_SUCCESS,
  GET_ORGANIZING_CHAPTERS,
  GET_ORGANIZING_CHAPTERS_ERROR,
  GET_ORGANIZING_CHAPTERS_SUCCESS,
  RESET_CHAPTER_LIST_BY_SUBJECT,
  TOGGLE_CHAPTER_STATE,
  TOGGLE_CHAPTER_STATE_ERROR,
  TOGGLE_CHAPTER_STATE_SUCCESS,
  UPDATE_CHAPTER,
  UPDATE_CHAPTER_ERROR,
  UPDATE_CHAPTER_SUCCESS,
} from "./actionTypes";

export class ChapterState {
  chapters!: State<Paginated<ChapterDto[]>>;
  chapter!: State<ChapterDto>;
  chaptersStats!: State<ChapterStatsDto[]>;
  chaptersSkillsStats!: State<ChapterSkillsStatsDto[]>;
  chaptersFlashCardsStats!: State<ChapterFlashCardsStatsDto[]>;
  chaptersLecturesStats!: State<ChapterLecturesStatsDto[]>;
  addChapter!: State<any>;
  updateChapter!: State<any>;
  deleteChapter!: State<any>;
  toggleChapterState: any;
  toggleLessonState: any;
  chapterSelectListBySubject: State<SelectListDto[]>;
  organizingChapters: State<Paginated<OrganizingChapterDto>>;
  constructor() {
    this.chapters = {
      loading: false,
      error: null,
      success: false,
    };
    this.chapter = {
      loading: false,
      error: null,
      success: false,
    };
    this.chaptersStats = {
      loading: false,
      error: null,
      success: false,
    };
    this.addChapter = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateChapter = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteChapter = {
      loading: false,
      error: null,
      success: false,
    };
    this.chaptersSkillsStats = {
      loading: false,
      error: null,
      success: false,
    };
    this.chaptersFlashCardsStats = {
      loading: false,
      error: null,
      success: false,
    };
    this.chaptersLecturesStats = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleChapterState = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleLessonState = {
      loading: false,
      error: null,
      success: false,
    };
    this.chapterSelectListBySubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.organizingChapters = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: ChapterState = new ChapterState();

export const chapter = (
  state: ChapterState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_CHAPTERS:
      state = {
        ...state,
        chapters: {
          ...state.chapters,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTERS_SUCCESS:
      state = {
        ...state,
        chapters: {
          ...state.chapters,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_ERROR:
      state = {
        ...state,
        chapters: {
          ...state.chapters,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTER:
      state = {
        ...state,
        chapter: {
          ...state.chapter,
          loading: true,
          success: false,
          error: null,
        },
        addChapter: {
          ...state.addChapter,
          loading: false,
          success: false,
          error: null,
        },
        updateChapter: {
          ...state.updateChapter,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTER_SUCCESS:
      state = {
        ...state,
        chapter: {
          ...state.chapter,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTER_ERROR:
      state = {
        ...state,
        chapter: {
          ...state.chapter,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_STATS:
      state = {
        ...state,
        chaptersStats: {
          ...state.chaptersStats,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTERS_STATS_SUCCESS:
      state = {
        ...state,
        chaptersStats: {
          ...state.chaptersStats,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_STATS_ERROR:
      state = {
        ...state,
        chaptersStats: {
          ...state.chaptersStats,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_CHAPTER:
      state = {
        ...state,
        addChapter: {
          ...state.addChapter,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_CHAPTER_SUCCESS:
      state = {
        ...state,
        addChapter: {
          ...state.addChapter,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_CHAPTER_ERROR:
      state = {
        ...state,
        addChapter: {
          ...state.addChapter,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case UPDATE_CHAPTER:
      state = {
        ...state,
        updateChapter: {
          ...state.updateChapter,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_CHAPTER_SUCCESS:
      state = {
        ...state,
        updateChapter: {
          ...state.updateChapter,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_CHAPTER_ERROR:
      state = {
        ...state,
        updateChapter: {
          ...state.updateChapter,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_CHAPTER_CONSENT:
      state = {
        ...state,
        deleteChapter: {
          ...state.deleteChapter,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_CHAPTER:
      state = {
        ...state,
        deleteChapter: {
          ...state.deleteChapter,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_CHAPTER_SUCCESS:
      state = {
        ...state,
        deleteChapter: {
          ...state.deleteChapter,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_CHAPTER_ERROR:
      state = {
        ...state,
        deleteChapter: {
          ...state.deleteChapter,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_SKILLS_STATS:
      state = {
        ...state,
        chaptersSkillsStats: {
          ...state.chaptersSkillsStats,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTERS_SKILLS_STATS_SUCCESS:
      state = {
        ...state,
        chaptersSkillsStats: {
          ...state.chaptersSkillsStats,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_SKILLS_STATS_ERROR:
      state = {
        ...state,
        chaptersSkillsStats: {
          ...state.chaptersSkillsStats,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_FLASH_CARDS_STATS:
      state = {
        ...state,
        chaptersFlashCardsStats: {
          ...state.chaptersFlashCardsStats,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS:
      state = {
        ...state,
        chaptersFlashCardsStats: {
          ...state.chaptersFlashCardsStats,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_FLASH_CARDS_STATS_ERROR:
      state = {
        ...state,
        chaptersFlashCardsStats: {
          ...state.chaptersFlashCardsStats,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_LECTURES_STATS:
      state = {
        ...state,
        chaptersLecturesStats: {
          ...state.chaptersLecturesStats,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTERS_LECTURES_STATS_SUCCESS:
      state = {
        ...state,
        chaptersLecturesStats: {
          ...state.chaptersLecturesStats,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTERS_LECTURES_STATS_ERROR:
      state = {
        ...state,
        chaptersLecturesStats: {
          ...state.chaptersLecturesStats,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_CHAPTER_STATE:
      state = {
        ...state,
        toggleChapterState: {
          ...state.toggleChapterState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_CHAPTER_STATE_SUCCESS:
      state = {
        ...state,
        toggleChapterState: {
          ...state.toggleChapterState,
          loading: false,
          error: null,
          success: true,
        },
        chaptersStats: {
          ...state.chaptersStats,
          response: state.chaptersStats?.response?.map(
            (chapterStatsDto: ChapterStatsDto) => {
              if (chapterStatsDto.id === action.payload.id)
                return {
                  ...chapterStatsDto,
                  isActive: !chapterStatsDto.isActive,
                };
              return chapterStatsDto;
            }
          ),
        },
        organizingChapters: {
          ...state.organizingChapters,
          response: {
            meta: state.organizingChapters.response?.meta,
            data: state.organizingChapters?.response?.data?.map(
              (item: OrganizingChapterDto) => {
                if (item.id === action.payload.id)
                  return {
                    ...item,
                    isActive: !item.isActive,
                  };
                return item;
              }
            ),
          },
        },
      };
      break;
    case TOGGLE_CHAPTER_STATE_ERROR:
      state = {
        ...state,
        toggleChapterState: {
          ...state.toggleChapterState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_LESSON_STATE:
      state = {
        ...state,
        toggleLessonState: {
          ...state.toggleLessonState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_LESSON_STATE_SUCCESS: {
      const { chapterId, lessonId } = action.payload;
      state = {
        ...state,
        toggleLessonState: {
          ...state.toggleLessonState,
          loading: false,
          error: null,
          success: true,
        },
        chaptersStats: {
          ...state.chaptersStats,
          response: state.chaptersStats.response?.map((chapter) => {
            if (chapter.id === chapterId) {
              return {
                ...chapter,
                lessons: chapter.lessons.map((lesson) => {
                  if (lesson.id === lessonId) {
                    return {
                      ...lesson,
                      isActive: !lesson.isActive,
                    };
                  }
                  return lesson;
                }),
              };
            }
            return chapter;
          }),
        },
        organizingChapters: {
          ...state.chaptersStats,
          response: {
            meta: state.organizingChapters?.response?.meta,
            data: state.organizingChapters.response?.data?.map(
              (chapter: OrganizingChapterDto) => {
                if (chapter.id === chapterId) {
                  return {
                    ...chapter,
                    lessons: chapter.lessons.map(
                      (lesson: OrganizingLessonDto) => {
                        if (lesson.id === lessonId) {
                          return {
                            ...lesson,
                            isActive: !lesson.isActive,
                          };
                        }
                        return lesson;
                      }
                    ),
                  };
                }
                return chapter;
              }
            ),
          },
        },
      };
      break;
    }
    case TOGGLE_LESSON_STATE_ERROR:
      state = {
        ...state,
        toggleLessonState: {
          ...state.toggleLessonState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_CHAPTER_LIST_BY_SUBJECT:
      state = {
        ...state,
        chapterSelectListBySubject: {
          ...state.chapterSelectListBySubject,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS:
      state = {
        ...state,
        chapterSelectListBySubject: {
          ...state.chapterSelectListBySubject,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CHAPTER_LIST_BY_SUBJECT_ERROR:
      state = {
        ...state,
        chapterSelectListBySubject: {
          ...state.chapterSelectListBySubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_CHAPTER_LIST_BY_SUBJECT:
      state = {
        ...state,
        chapterSelectListBySubject: {
          ...state.chapterSelectListBySubject,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_ORGANIZING_CHAPTERS:
      state = {
        ...state,
        organizingChapters: {
          ...state.organizingChapters,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_ORGANIZING_CHAPTERS_SUCCESS:
      state = {
        ...state,
        organizingChapters: {
          ...state.organizingChapters,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_ORGANIZING_CHAPTERS_ERROR:
      state = {
        ...state,
        organizingChapters: {
          ...state.organizingChapters,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
